<template>
  <v-container
    fluid
    pa-0
  >
    <v-row>
      <v-col
        class="text-center"
        cols="12"
      >
        <div
          class="d-inline-block text-left"
          style="width:100%; max-width: 560px"
        >
          <h2 class="brand-text-heading">
            {{ pageTitle.toLocaleUpperCase($i18n.locale) }}
          </h2>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="text-center"
        cols="12"
      >
        <div
          v-safe-html="pageContent"
          class="d-inline-block text-justify"
          style="width:100%; max-width: 560px"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageContentMixin from '@/theme/default/views/pages/PageContent.js'

export default {
  name  : 'PageContent',
  mixins: [PageContentMixin]
}
</script>

<style scoped src="@/theme/default/views/pages/PageContent.css"></style>
<style scoped>
/deep/ table, /deep/ th, /deep/ td {
  border: 1px solid;
  font-size: 12px;
  text-align: left;
}

/deep/ table {
  border-collapse: collapse;
}

/deep/ th, /deep/ td {
  padding: 6px;
}

/deep/ thead {
  font-weight: bold;
}
</style>
